const URL_DICTIONARY = {
  HTTP: process.env.REACT_APP_HTTP,
  HTTPS: process.env.REACT_APP_HTTPS,

  API_HOST: process.env.REACT_APP_API_HOST,
  PARTNER_HOST: process.env.REACT_APP_PARTNER_HOST,
  CONNECT_HOST: process.env.REACT_APP_CONNECT_HOST,
  NSIMS_API: process.env.REACT_APP_NSIMS_API,

  API_PORT: process.env.REACT_APP_API_PORT,
  PARTNER_API_PORT: process.env.REACT_APP_PARTNER_API_PORT,
  CONNECT_PORT: process.env.REACT_APP_CONNECT_PORT,
  NSIMS_PORT: process.env.REACT_APP_NSIMS_PORT,


  FILES_API: process.env.REACT_APP_FILES_API,
  FILE_VIEWER: process.env.REACT_APP_FILE_VIEWER,
  FMS: process.env.REACT_APP_FMS_HOST,

  REPORT_HOST: process.env.REACT_APP_REPORT_HOST,
  REPORT_PATH: process.env.REACT_APP_REPORT_PATH,
  ATTACHMENT_PATH: process.env.REACT_APP_ATTACHMENT_PATH,

  SOURCE_ID: Number(process.env.REACT_APP_SOURCE_ID),
};

const withPort = (host, port) => (port ? `${host}:${port}` : host);
const hostname = typeof window !== "undefined" ? window.location.hostname : "";
let SOURCE_ID = URL_DICTIONARY.SOURCE_ID

// ---------------------- FMS DETAILS ----------------------
let FMSDomain = URL_DICTIONARY.HTTPS + URL_DICTIONARY.FMS + "/";

// ---------------------- PATHS ----------------------
let ImagesBasePath = URL_DICTIONARY.HTTPS + URL_DICTIONARY.FILES_API + "/";
let ActiveReportPath = URL_DICTIONARY.HTTPS + URL_DICTIONARY.FILE_VIEWER + "/" + URL_DICTIONARY.REPORT_PATH + "/";
let FileViewBasePath = URL_DICTIONARY.HTTPS + URL_DICTIONARY.FILE_VIEWER + "/" + URL_DICTIONARY.ATTACHMENT_PATH + "/";

// ---------------------- DOMAINS ----------------------
let BaseDomain = URL_DICTIONARY.HTTP + withPort(URL_DICTIONARY.API_HOST, URL_DICTIONARY.API_PORT) + "/";
let PartnerBaseDomain = URL_DICTIONARY.HTTP + withPort(URL_DICTIONARY.PARTNER_HOST, URL_DICTIONARY.PARTNER_API_PORT) + "/";
let ConnectDomain = URL_DICTIONARY.HTTP + withPort(URL_DICTIONARY.CONNECT_HOST, URL_DICTIONARY.CONNECT_PORT) + "/";
let nSIMSDomain = URL_DICTIONARY.HTTP + withPort(URL_DICTIONARY.NSIMS_API, URL_DICTIONARY.NSIMS_PORT) + "/";

try {
  // if ports are empty (production), switch to HTTPS
  if (!URL_DICTIONARY.API_PORT) {
    BaseDomain = URL_DICTIONARY.HTTPS + URL_DICTIONARY.API_HOST + "/";
  }

  if (!URL_DICTIONARY.PARTNER_API_PORT) {
    PartnerBaseDomain = URL_DICTIONARY.HTTPS + URL_DICTIONARY.PARTNER_HOST + "/";
  }

  if (!URL_DICTIONARY.CONNECT_PORT) {
    ConnectDomain = URL_DICTIONARY.HTTPS + URL_DICTIONARY.CONNECT_HOST + "/";
  }

  if (!URL_DICTIONARY.NSIMS_PORT) {
    nSIMSDomain = URL_DICTIONARY.HTTPS + URL_DICTIONARY.NSIMS_API + "/";
  }

  if (URL_DICTIONARY.REPORT_HOST) {
    ActiveReportPath = URL_DICTIONARY.HTTPS + URL_DICTIONARY.REPORT_HOST + "/" + URL_DICTIONARY.REPORT_PATH + "/";
  }
} catch (error) {
  console.error("Failed to detect environment:", error);
}
//  ---------------------- SOURCE_ID ----------------------
if (hostname.includes("portal.idenpro.com")) {
  SOURCE_ID = 8;
} else {
  SOURCE_ID = 6; //hostname.includes("portal.sivagroup.co")
}

// ---------------------- EXPORT ----------------------
export const BASE = Object.freeze({
  FMSDomain: FMSDomain,
  ConnectDomain: ConnectDomain,
  BaseDomain: BaseDomain,
  PartnerBaseDomain: PartnerBaseDomain,
  ImagesBasePath: ImagesBasePath,
  REPORT_BASEPATH: ActiveReportPath,
  URL_DICTIONARY: URL_DICTIONARY,
  SOURCE_ID: SOURCE_ID,
  FILEVIEWER_BASEPATH: FileViewBasePath,
  nSIMSDomain: nSIMSDomain
});
